// extracted by mini-css-extract-plugin
export default {"container":"container__YB_n38D8","truncate":"truncate__pilKx8yb"};